import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
const withRouter = WrappedComponent => props => {
  var params = useParams();
  var navigate = useNavigate();
  var location = useLocation();

  useEffect(() => {
  }, [location]);

  var queryParams = new URLSearchParams(location.search);
  return (
    <WrappedComponent
      {...props}
      params={params}
      navigate={navigate}
      queryParam={queryParams}
    />
  );
};

export default withRouter;